import a from "styled-components";
import { Base as u } from "./atoms-v2777.js";
const $ = (o, s, r, g) => {
  if (g && s === "outline")
    return `
      background-color: ${r == null ? void 0 : r.get(`tokens.surface.${o}.background`)};
      border: 1px solid ${r == null ? void 0 : r.get(`tokens.border.${o}.dark`)};
      color: ${r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};

      ${n} {
        cursor: not-allowed;
      }
    `;
  if (g)
    return `
      background-color: ${r == null ? void 0 : r.get(`tokens.surface.${o}.layer01`)};
      color: ${r == null ? void 0 : r.get(`tokens.text.${o}.disabled`)};

      ${n} {
        cursor: not-allowed;
      }
    `;
  switch (s) {
    case "primary":
      return `
        background-color: ${r == null ? void 0 : r.get(`tokens.surface.${o}.backgroundInverse`)};
        color: ${r == null ? void 0 : r.get(`tokens.text.${o}.inverse`)};

        ${n}:focus {
          border-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.focusInverse`)};
          outline: none;
        }
      `;
    case "success":
      return `
          background-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.bkgSuccess`)};
          color: ${r == null ? void 0 : r.get(`ui.tag.${o}.textSuccess`)};

          ${n}:hover {
            background-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.bkgSuccessHover`)};
          }

          ${n}:focus {
            border-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.focus`)};
            outline: none;
          }
        `;
    case "error":
      return `
          background-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.bkgError`)};
          color: ${r == null ? void 0 : r.get(`ui.tag.${o}.textError`)};

          ${n}:hover {
            background-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.bkgErrorHover`)};
          }

          ${n}:focus {
            border-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.focus`)};
            outline: none;
          }
        `;
    case "gray":
      return `
          background-color: ${r == null ? void 0 : r.get(`tokens.surface.${o}.layer01`)};
          color: ${r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};

          ${n}:hover {
            background-color: ${r == null ? void 0 : r.get(`ui.button.ghost.${o}.light.active`)};
            color: ${r == null ? void 0 : r.get(`ui.button.secondary.${o}.text`)};
          }

          ${n}:focus {
            border-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.focus`)};
            color: ${r == null ? void 0 : r.get(`ui.button.secondary.${o}.text`)};
            outline: none;
          }
        `;
    case "outline":
      return `
          background-color: ${r == null ? void 0 : r.get(`tokens.surface.${o}.background`)};
          border: 1px solid ${r == null ? void 0 : r.get(`tokens.border.${o}.dark`)};
          color: ${r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};

          ${n}:hover {
            background-color: ${r == null ? void 0 : r.get(`ui.button.ghost.${o}.light.active`)};
          }

          ${n}:focus {
            border-color: ${r == null ? void 0 : r.get(`ui.tag.${o}.focus`)};
            outline: none;
          }
        `;
  }
}, i = (o) => {
  switch (o) {
    case "small":
      return `
        height: 18px;
      `;
    case "medium":
      return `
        height: 24px;
      `;
  }
}, k = a.div`
  ${u}

  align-items: center;
  border-radius: 24px;
  column-gap: 2px;
  display: flex;

  ${({ $size: o }) => i(o)}
  ${({ $colorTheme: o, $isDisabled: s, $variant: r, theme: g }) => $(o, r, g, s)}
`, l = a.span`
  padding: 0 8px 2px;
  ${({ theme: o }) => {
  var s;
  return (s = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : s.toJS();
}}
`, n = a.button`
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 24px;
  color: inherit;
  cursor: pointer;
  height: ${({ $size: o }) => o === "small" ? "18px" : "24px"};
  padding: ${({ $size: o }) => o === "small" ? "0px" : "3px"};
  text-align: center;
  transition:
    background-color ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.fast")}
      ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")},
    border-color ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.fast")}
      ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")};
  width: ${({ $size: o }) => o === "small" ? "18px" : "24px"};
`;
export {
  k as Tag,
  n as TagCloseButton,
  l as TagContent
};
